module.exports = __webpack_public_path__ + "img/logo.7727ce70.webp";